import { useTranslation } from "react-i18next";
import CheckSquareIcon from "../../icons/checkSquareIcon";
import DollarSquareIcon from "../../icons/dollarSquareIcon";
import NetworkIcon from "../../icons/networkIcon";
import UsersIcon from "../../icons/usersIcon";

const Advantages = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="w-11/12 mx-auto ">
        <h1 className="text-[24px] md:text-[32px] font-bold my-5 text-mainBlue text-center">
          {t("ourAdvantages")}
        </h1>
        <section className="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="bg-[#F7F9FF] rounded-2xl p-8 flex gap-4">
            <NetworkIcon className="size-8" />
            <div className="w-[70%]">
              <h1 className="text-[18px] md:text-[20px] font-bold">
                {t("globalReach")}
              </h1>
              <p className="text-mainGray">{t("weDeliver")}</p>
            </div>
          </div>
          <div className="bg-[#F7F9FF] rounded-2xl p-8 flex gap-4">
            <UsersIcon className="size-8" />
            <div className="w-[70%]">
              <h1 className="text-[18px] md:text-[20px] font-bold">
                {t("experiencedTeam")}
              </h1>
              <p className="text-mainGray">{t("logisticsExperts")}</p>
            </div>
          </div>
          <div className="bg-[#F7F9FF] rounded-2xl p-8 flex gap-4">
            <CheckSquareIcon fill="#FF0000" className="size-8" />
            <div className="w-[70%]">
              <h1 className="text-[18px] md:text-[20px] font-bold">
                {t("reliableTracking")}
              </h1>
              <p className="text-mainGray">{t("realTimeShipment")}</p>
            </div>
          </div>
          <div className="bg-[#F7F9FF] rounded-2xl p-8 flex gap-4">
            <DollarSquareIcon className="size-8" />
            <div className="w-[70%]">
              <h1 className="text-[18px] md:text-[20px] font-bold">
                {t("affordableRates")}
              </h1>
              <p className="text-mainGray">{t("competitivePricing")}</p>
            </div>
          </div>
        </section>
      </div>
    </article>
  );
};

export default Advantages;
